import React from 'react'
import { Helmet } from 'react-helmet';

export const DynamicTitle = ({title}) =>(
<Helmet>
       <title>{title}</title>
     </Helmet>)
